
























import { Col, Row, Image, Lazyload } from 'vant';
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { ArchivesInfo, nullArchivesInfo } from '@/data/local/archives';


Vue.use(Col);
Vue.use(Row);
Vue.use(Image);
Vue.use(Lazyload);

@Component({})
export default class ArchivesItem extends Vue {
  @Prop(Object)
  private itemData: ArchivesInfo;

  created() {
    
  }

  mounted() {
    
  }

  private onClickItem() {
    this.$router.push({path: "/fund/news/detail", query:{ url: encodeURI(this.itemData.url)}});
  }
}
